import React, { useEffect, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import dayjs from "dayjs";
import { Divider, Flex } from "antd";

const GenerateAgreement = (props) => {
  const activeStatus = props?.urlparams?.params?.status;
  const path = props?.urlparams?.params?.path;
  const [data, setData] = useState({});
  const [applData, setApplData] = useState({});
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [validationResponse, setValidationResponse] = useState(null);
  const [agreementPayload, setAgreementPayload] = useState(null);
  const [pfPercent, setPfPercent] = useState(10);

  const [fields, setFields] = useState([
    {
      name: "borrowerName",
      label: "Customer Name",
      type: "text",
      readOnly: true,
    },
    { name: "mobileNumber", label: "Mobile No.", type: "text", readOnly: true },
    { name: "emailAddress", label: "Email ID", type: "text", readOnly: true },
    {
      name: "loanAccountNumber",
      label: "Loan Account No",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanAmount",
      label: "Sanctioned Loan amount",
      type: "number",
      onChange: (date) => handleLoanAmountChange(date),
      // readOnly: true,
    },
    {
      name: "totalPfPercent",
      label: "PF Percent",
      type: "number",
      readOnly: true,
      colspan: 3,
    },
    {
      name: "sanctionedLoanTenure",
      label: "Tenure",
      type: "number",
      onChange: (date) => handleTenureChange(date),
    },
    { name: "sanctionedLoanIRR", label: "ROI", type: "text", readOnly: true },
    {
      name: "sanctionedLoanPF",
      label: "Processing Fees",
      type: "text",
      readOnly: true,
    },
    {
      name: "gst",
      label: "GST (18%)",
      type: "number",
      readOnly: true,
    },
    {
      name: "loanPaymentMode",
      label: "Repayment Type",
      type: "text",
      readOnly: true,
    },
    {
      name: "sanctionedLoanStartDate",
      label: "Loan Start date",
      type: "date",
      onChange: (date) => handleStartDateChange(date),
      disabledDate: (current) => {
        return current && current < moment().startOf("day") + 1;
      },
      required: true,
    },
    {
      name: "sanctionedEMIDate",
      label: "EMI Start Date",
      type: "date",
      required: true,
    },
    {
      name: "sanctionedNoOfMonth",
      label: "No. Of EMIs",
      type: "select",
      options: _enum.NO_OF_MONTHS,
    },
    {
      name: "sanctionedLoanEndDate",
      label: "Loan End date",
      type: "date",
      dateClassName: "fakedisabled",
    },
    {
      name: "sanctionedLoanTotalAmtPayable",
      label: "Total Amt payable",
      type: "text",
      readOnly: true,
    },
    // {
    //   name: "stampDutyNum",
    //   label: "Stamp Duty No.",
    //   type: "number",
    //   required: true,
    // },
    {
      name: "netDisbursementAmt",
      label: "Net Disbursement Amt.",
      type: "number",
      readOnly: true,
      required: true,
      colspan: 3,
    },
    // {
    //   name: "isEmandateRequired",
    //   label: "E-Mandate Required?",
    //   type: "radio",
    //   options: [
    //     { value: true, label: "Yes" },
    //     { value: false, label: "No" },
    //   ],
    //   defaultValue: false,
    //   required: true,
    // },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      required: true,
      colspan: 12,
    },
  ]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleStartDateChange = (date) => {
    let duration = document.querySelector(
      "[name='sanctionedLoanTenure']"
    ).value;

    let loanEndDateValue = dayjs(date).add(duration - 1, "day");

    let endDateContainer = document.querySelector("[name='appinput-sanctionedLoanEndDate']");
    if (endDateContainer && endDateContainer.vnode) {
      endDateContainer.vnode.handleDateChange(dayjs(loanEndDateValue).format("YYYY-MM-DD"));
    } else {
      document.querySelector("[name='sanctionedLoanEndDate']").value =
        dayjs(loanEndDateValue).format("YYYY-MM-DD");
    }

    // calculate total payable amount
    let loanAmount = document.querySelector(
      "[name='sanctionedLoanAmount']"
    ).value;
    let roiVal = document.querySelector("[name='sanctionedLoanIRR']").value;
    let interestAmount = Number(loanAmount) * (Number(roiVal) / 100) * duration;
    let totalAmount = (Number(loanAmount) + interestAmount).toFixed(2);
    document.querySelector("[name='sanctionedLoanTotalAmtPayable']").value =
      totalAmount;
  };

  const handleTenureChange = (e) => {
    let duration = e.target.value;

    let loanStartDateValue = document.querySelector(
      "[name='sanctionedLoanStartDate']"
    ).value;

    if (loanStartDateValue) {
      let loanEndDateValue = dayjs(loanStartDateValue).add(duration - 1, "day");

      let endDateContainer = document.querySelector("[name='appinput-sanctionedLoanEndDate']");
      if (endDateContainer && endDateContainer.vnode) {
        endDateContainer.vnode.handleDateChange(dayjs(loanEndDateValue).format("YYYY-MM-DD"));
      } else {
        document.querySelector("[name='sanctionedLoanEndDate']").value =
          dayjs(loanEndDateValue).format("YYYY-MM-DD");
      }

      // calculate total payable amount
      let loanAmount = document.querySelector(
        "[name='sanctionedLoanAmount']"
      ).value;

      let roiVal = document.querySelector("[name='sanctionedLoanIRR']").value;

      let interestAmount =
        Number(loanAmount) * (Number(roiVal) / 100) * duration;

      let totalAmount = (Number(loanAmount) + interestAmount).toFixed(2);

      document.querySelector("[name='sanctionedLoanTotalAmtPayable']").value =
        totalAmount;
    }
  };


  const percentageCalc = (percent, total) => {
    return ((percent / 100) * total).toFixed(2);
  };

  const handleLoanAmountChange = (e) => {
    e.preventDefault();
    let loanAmount = e.target.value;

    // PF calc
    let pfPercentInput = document.querySelector("[name='totalPfPercent']");
    let pfPercentVal = pfPercentInput ? (pfPercentInput.value || pfPercent) : pfPercent;

    let processingFee = (Number(pfPercentVal) / 100) * Number(loanAmount);
    let GSTFee = 0.18 * processingFee;
    let netDisburseAmnt = Number(loanAmount) - (processingFee + GSTFee);

    // setting calculated values
    let pfField = document.querySelector("[name='sanctionedLoanPF']");
    if (pfField) pfField.value = Number(processingFee).toFixed(2);

    let gstField = document.querySelector("[name='gst']");
    if (gstField) gstField.value = Number(GSTFee).toFixed(2);

    let netAmtField = document.querySelector("[name='netDisbursementAmt']");
    if (netAmtField) netAmtField.value = Math.ceil(Number(netDisburseAmnt));

    // --------------
    let endDateContainer = document.querySelector("[name='appinput-sanctionedLoanEndDate']");
    if (endDateContainer && endDateContainer.vnode) {
      endDateContainer.vnode.clearValues();
    } else {
      let endDateField = document.querySelector("[name='sanctionedLoanEndDate']");
      if (endDateField) endDateField.value = null;
    }

    let startDateContainer = document.querySelector("[name='appinput-sanctionedLoanStartDate']");
    if (startDateContainer && startDateContainer.vnode) {
      startDateContainer.vnode.clearValues();
    } else {
      let startDateField = document.querySelector("[name='sanctionedLoanStartDate']");
      if (startDateField) startDateField.value = null;
    }
  };

  const updateDefaults = (arr, applicationData) => {
    return arr.map((o) => {
      let defaultValue = applicationData[o.name] || o.defaultValue || "";
      if (o.type == "select") {
        if (o.getOptions instanceof Function && o.options.length == 0) {
          o.options = o.getOptions(applicationData);
        }
        if (
          typeof defaultValue == "string" &&
          defaultValue.split(",").length > 1
        ) {
          defaultValue = defaultValue
            .split(",")
            .map((key) => o.options.find((o) => o.value == key));
        } else if (o.multiple) {
          defaultValue = o.options?.filter((o) =>
            defaultValue?.includes(o.value)
          );
        } else {
          defaultValue = o.options?.find((o) => o.value == defaultValue);
        }
      }
      if (o.type === "date") {
        console.log({ name: o.name, defaultValue });
        return {
          ...o,
          defaultValue: defaultValue,
        };
      }
      if (o.type === "radio") {
        return {
          ...o,
          defaultValue: applicationData[o.name],
        };
      }
      if (o.name === "sanctionedLoanTotalAmtPayable") {
        let interestRate = applicationData.sanctionedLoanIRR;
        let loanAmount = applicationData.sanctionedLoanAmount;
        let loanduration = applicationData.sanctionedLoanTenure;
        console.log({
          interestRate,
          loanAmount,
          loanduration,
        });
        let interestAmount = loanAmount * (interestRate / 100) * loanduration;
        let totalAmount = (loanAmount + interestAmount).toFixed(2);
        return {
          ...o,
          defaultValue: totalAmount,
        };
      }
      if (o.name === "totalPfPercent") {
        let pct = applicationData?.sanctionedLoanPctPF || 10;
        const reverseMap = { 1: 6, 2: 7, 3: 8, 4: 9, 5: 10 };
        defaultValue = reverseMap[pct] || pct;
        setPfPercent(defaultValue);
      }
      if (o.name === "sanctionedLoanPF") {
        let pct = applicationData?.sanctionedLoanPctPF || 10;
        const reverseMap = { 1: 6, 2: 7, 3: 8, 4: 9, 5: 10 };
        let actualPct = reverseMap[pct] || pct;
        let loanAmount = applicationData?.sanctionedLoanAmount || 0;
        let processingFee = (actualPct / 100) * loanAmount;
        defaultValue = Number(processingFee).toFixed(2);
      }
      if (o.name === "gst") {
        let pct = applicationData?.sanctionedLoanPctPF || 10;
        const reverseMap = { 1: 6, 2: 7, 3: 8, 4: 9, 5: 10 };
        let actualPct = reverseMap[pct] || pct;
        let loanAmount = applicationData?.sanctionedLoanAmount || 0;
        let processingFee = (actualPct / 100) * loanAmount;
        let gst = 0.18 * processingFee;
        defaultValue = Number(gst).toFixed(2);
      }
      if (o.name === "netDisbursementAmt") {
        let pct = applicationData?.sanctionedLoanPctPF || 10;
        const reverseMap = { 1: 6, 2: 7, 3: 8, 4: 9, 5: 10 };
        let actualPct = reverseMap[pct] || pct;
        let loanAmount = applicationData?.sanctionedLoanAmount || 0;
        let processingFee = (actualPct / 100) * loanAmount;
        let gst = 0.18 * processingFee;
        defaultValue = Math.ceil(loanAmount - (processingFee + gst));
      }
      return {
        ...o,
        defaultValue,
      };
    });
  };

  // -----------  EMI CALCULATION  -----------
  const [showAmortCalc, setShowAmortCalc] = useState(true);
  const [amortCalcResponse, setAmortCalcResponse] = useState({});
  const [emiSchedule, setEmiSchedule] = useState([]);
  const amortizationColumns = [
    {
      dataIndex: "emiNumber",
      title: "Seq.",
    },
    {
      dataIndex: "date",
      title: "Payment Date",
      render: (text, record) => {
        return <span>{text || "-"}</span>;
      },
    },
    {
      dataIndex: "outstanding",
      title: "Principal Outstanding",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "emi",
      title: "EMI Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "principal",
      title: "Principal",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "interest",
      title: "Interest",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
  ];

  const calculateAmortization = (e) => {
    let loanAmountValue = document.querySelector(
      '[name="sanctionedLoanAmount"]'
    )?.value;

    // ROI - sanctionedIRR
    let roiValue = document.querySelector('[name="sanctionedLoanIRR"]')?.value;

    // Loan Start Date - sanctionedLoanStartDate
    let loanStartDateVal = document.querySelector(
      '[name="sanctionedLoanStartDate"]'
    ).value;

    // EMI Start Date - sanctionedEMIDate
    let emiStartDateVal = document.querySelector(
      '[name="sanctionedEMIDate"]'
    ).value;

    // No of Emi's - sanctionedNoOfMonth
    let numberOfEmisVal = document.querySelector(
      '[name="sanctionedNoOfMonth"]'
    ).value;

    let payload = {
      loanAmount: Number(loanAmountValue || null),
      roi: Number(roiValue || null),
      loanStartDate: loanStartDateVal
        ? new Date(loanStartDateVal).toISOString()
        : null,
      emiStartDate: emiStartDateVal
        ? new Date(emiStartDateVal).toISOString()
        : null,
      numberOfEmis: Number(numberOfEmisVal || null),
      penalCharge: 0,
    };

    console.log({ payload });

    props.apis.apiUnderWriterCalculateLoanAmortization(payload).then((res) => {
      console.log({ res });
      if (res) {
        setAmortCalcResponse(res?.data);
        const alteredSchedule = res?.data?.schedule?.map((item) => ({
          emiSequence: item.emiNumber,
          emiRepaymentDate: new Date(item.date).toISOString(),
          interestCalculateDays: item.days,
          interestAmt: item.interest,
          principalAmt: item.principal,
          outstandingAmt: item.outstanding,
          emiAmt: item.emi,
        }));
        setEmiSchedule(alteredSchedule);

        // set tenure value in the form
        document.querySelector('[name="tenure"]').value = res?.data?.tenure;

        // set Total Amt payable
        let totalAmnt = res?.data?.loanAmount + res?.data?.totalInterest;

        document.querySelector("[name='sanctionedLoanTotalAmtPayable']").value =
          totalAmnt?.toFixed(2);

        // Final EMI Amount - sanctionedEMIAmt
        // document.querySelector('[name="sanctionedEMIAmt"]').value =
        //   res?.data?.fixedEMI;
      }
    });
  };

  // function to compare only yyyy-mm-dd
  const isDateHoliday = (list, date) => {
    const check = date.toISOString().split("T")[0]; // "2026-01-01"

    return list.some((item) => {
      const holidayDate = new Date(item.date).toISOString().split("T")[0];
      console.log({ holidayDate, check });

      return holidayDate === check;
    });
  };

  const handleAgreement = (e, data) => {
    // let payload = { ...data, isEmandateRequired: data?.isEmandateRequired === "true" ? true : false };
    let payload = { ...data, isEmandateRequired: false };
    if (payload?.sanctionedLoanStartDate) {
      for (let key in data) {
        if (
          key.includes("Amt") ||
          key.includes("Amount") ||
          key.includes("Tenure") ||
          key.includes("IRR") ||
          key.includes("LoanPF")
        ) {
          payload[key] = parseFloat(payload[key] || 0);
        }
      }
      const resolve = (res) => {
        // Create a PDF download link
        let atag = document.createElement("a");
        atag.href = res?.pdf || "";
        atag.download = "loan-agreement.pdf";
        atag.setAttribute("target", "_blank");
        document.body.appendChild(atag);
        atag.click();
        document.body.removeChild(atag);

        navigate(`/app/loanapplications?activetab=${activeStatus}`);
        swal2.fire({
          title: `Loan ${path === "generateagreement" ? "Generated" : "Re-Generated"
            } Successfully`,
          icon: "success",
          iconColor: "#DE3232",
          timer: 3000,
          confirmButtonText: "Close",
        });
      };

      swal2
        .fire({
          title: `Are you sure want to ${path === "generateagreement" ? "generate" : "re-generate"
            } the agreement`,
          icon: "info",
          iconColor: "#DE3232",
          showCancelButton: true,
          confirmButtonColor: "#DE3232",
          cancelButtonColor: "##D6DBE7",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            payload = {
              ...Object.except(payload, [
                "loanAccountNumber",
                "totalPfPercent",
              ]),
              sanctionedLoanStartDate: new Date(
                data?.sanctionedLoanStartDate
              ).toISOString(),
              sanctionedLoanEndDate: new Date(
                data?.sanctionedLoanEndDate
              ).toISOString(),
            };
            const date = new Date(payload?.sanctionedLoanEndDate);
            const isSunday = date.getUTCDay() === 0;

            // Fetch holidays
            const { data: holidayData } =
              await props.apis.apiGetMasterHolidays();

            const isHoliday = holidayData
              ? isDateHoliday(holidayData, date)
              : false;

            if (isSunday) {
              swal2.fire({
                title: "Loan end date falls on sunday",
                text: "please adjust the tenure",
                icon: "warning",
                iconColor: "#FF4D4D",
              });
              return;
            } else if (isHoliday === true) {
              swal2.fire({
                title: "Loan end date falls on a holiday",
                text: "please adjust the tenure",
                icon: "warning",
                iconColor: "#FF4D4D",
              });
              return;
            } else {
              if (payload?.loanPaymentMode !== "EMI") {
                payload = {
                  ...Object.except(payload, [
                    "sanctionedEMIDate",
                    "sanctionedNoOfMonth",
                    "totalEmiInterest",
                  ]),
                };
              } else {
                payload = {
                  ...payload,
                  sanctionedEMIDate: new Date(
                    data?.sanctionedEMIDate
                  ).toISOString(),
                  sanctionedNoOfMonth: Number(data?.sanctionedNoOfMonth),
                  totalEmiInterest: amortCalcResponse?.totalInterest,
                  gst: Number(data?.gst),
                };

                // send EMI schedules into EMI update API
                let emiPayload = {
                  emiSchedules: amortCalcResponse?.schedule
                    ?.map((item, index) => {
                      const matchedSchedule = applData?.emiSchedules?.[index];
                      if (!matchedSchedule) return null;
                      return {
                        scheduleId: matchedSchedule.scheduleId,
                        emiSequence: item.emiNumber,
                        emiRepaymentDate: new Date(item.date).toISOString(),
                        interestCalculateDays: item.days,
                        interestAmt: item.interest,
                        principalAmt: item.principal,
                        outstandingAmt: item.outstanding,
                        emiAmt: item.emi,
                      };
                    })
                    .filter(Boolean), // removes nulls
                };
                console.log({ emiPayload });
                // UPDATE EMI SCHEDULES
                props.apis
                  .apiUnderWriterUpdateEmiSchedule(emiPayload, {
                    applicationId: props.urlparams.params.id,
                  })
                  .then((res) => {
                    console.log({ res });
                  });
              }
              console.log({ payload });
              payload.gst = Number(payload.gst || 0);
              payload.loanAccountNumber = applData.loanAccountNumber;
              setData(payload)
              props.apis.apiUnderWriterAccountsValidate(payload).then((res) => {
                console.log({ res });
                setValidationResponse(res?.data || res);
                setAgreementPayload(Object.except(payload, ["loanAccountNumber"]));
                setShowPreviewModal(true);
              });
            }
          }
        });
    } else {
      swal2.fire({
        title: "Please select loan start date",
        // text: "Please try again later",
        icon: "warning",
        iconColor: "#FF4D4D",
      });
    }
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
          const result = id.replace(/^column-/, "");
          let input = document.querySelector(`input[name="${result}"]`);
          input?.removeAttribute("required");
          if (
            input?.getAttribute("type") !== "select" &&
            !input.hasAttribute("required")
          ) {
            input.setAttribute("required", true);
          }
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
          const result = id.replace(/^column-/, "");
          let input = document.querySelector(`input[name="${result}"]`);
          input?.removeAttribute("required");
        }
      });
    }
  };

  const getData = () => {
    props.apis
      .apiGetUnderWriterLoanApplicationDetails({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        if (res) {
          setApplData(res);
          let inputs = [
            "column-sanctionedNoOfMonth",
            // "column-sanctionedEMIAmt",
            "column-sanctionedEMIDate",
          ];
          if (res?.loanPaymentMode === "BULLET") {
            hideInputs(inputs);
            // showInputs(["column-sanctionedTenure"]);
            setShowAmortCalc(false);
          } else {
            showInputs(inputs);
            // hideInputs(["column-sanctionedTenure"]);
            setShowAmortCalc(true);
          }

          let updatedFieldArray = updateDefaults(fields, res);
          setFields(updatedFieldArray);
          console.log({ updatedFieldArray });
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getData();

    // Prevent Tab key from moving focus
    const handleKeyDown = (e) => {
      if (e.key === "Tab" || e.keyCode === 9) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleProceedAgreement = () => {
    setShowPreviewModal(false);
    const resolve = (res) => {
      let atag = document.createElement("a");
      atag.href = res?.pdf || res?.data?.pdf || "";
      atag.download = "loan-agreement.pdf";
      atag.setAttribute("target", "_blank");
      document.body.appendChild(atag);
      atag.click();
      document.body.removeChild(atag);

      try {
        navigate(`/app/loanapplications?activetab=${activeStatus}`);
      } catch (e) {
        if (props.navigate) {
          props.navigate(`/app/loanapplications?activetab=${activeStatus}`);
        }
      }
      swal2.fire({
        title: `Loan ${path === "generateagreement" ? "Generated" : "Re-Generated"} Successfully`,
        icon: "success",
        iconColor: "#DE3232",
        timer: 3000,
        confirmButtonText: "Close",
      });
    };

    if (path === "generateagreement") {
      props.apis
        .apiUnderWriterGenerateAgreement(agreementPayload, {
          loanAccountNumber: applData.loanAccountNumber,
        })
        .then((res) => {
          resolve(res);
        });
    } else {
      props.apis
        .apiUnderWriterReGenerateAgreement(agreementPayload, {
          loanAccountNumber: applData.loanAccountNumber,
        })
        .then((res) => {
          resolve(res);
        });
    }
  };

  return (
    <>
      <MainPagetitle
        mainTitle={`My Applications | ${activeStatus.toTitleCase()} | ${path === "generateagreement" ? "Generate" : "Re-generate"
          } Agreement`}
        back={data?.borrowerName || ""}
        backLink={`/app/loanapplications?activetab=${activeStatus}`}
        pageTitle={"My Application"}
        parentTitle={"Home"}
        pageIcon={imagepaths.applicationCheckImg}
      />
      <div className="container-fluid">
        <div className="card p-4">
          <AppForm className="mx-0" onSubmit={handleAgreement}>
            {fields?.map((field, i) => (
              <>
                <div
                  className={`col-12 col-md-${field?.colspan || 4}`}
                  id={`column-${field?.name}`}
                >
                  <AppInput {...field}></AppInput>
                </div>

                {showAmortCalc &&
                  field?.name === "sanctionedLoanTotalAmtPayable" && (
                    <div className="col-12 mb-4">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <AppInput
                            name="tenure"
                            type="text"
                            label="Tenure"
                            readOnly={true}
                            disabled={true}
                          ></AppInput>
                        </div>
                        <div className="col-12 col-md-4 d-flex align-items-end">
                          <button
                            type="button"
                            className="btn btn-primary mb-3"
                            onClick={(...args) =>
                              calculateAmortization(...args)
                            }
                          >
                            Calculate
                          </button>
                        </div>
                      </div>

                      <Divider />
                      <Flex wrap gap="small" className="mb-4">
                        <div class="obligation_banner small">
                          <p class="">
                            Principal Amount Disbursed : Rs.{" "}
                            <span>{amortCalcResponse?.loanAmount?.cur()}</span>
                          </p>
                        </div>
                        <div class="obligation_banner small">
                          <p class="">
                            Total Interest : Rs.{" "}
                            <span>
                              {amortCalcResponse?.totalInterest?.cur()}
                            </span>
                          </p>
                        </div>
                      </Flex>
                      <AppTable
                        data={amortCalcResponse?.schedule || []}
                        columns={amortizationColumns}
                        total={amortCalcResponse?.schedule?.length || 0}
                        reorder={true}
                        viewable={false}
                        deletable={false}
                        editable={false}
                      />
                    </div>
                  )}
              </>
            ))}

            <div className="nav_container">
              <Link
                to={`/app/loanapplications?activetab=${activeStatus}`}
                className="btn btn-primary-lite me-3"
              >
                Cancel
              </Link>
              {/* <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(...args) => handleShow(...args)}
              >
                Preview
              </button> */}
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </AppForm>
        </div>
      </div>

      {/* PREVIEW MODAL */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        className="preview_agreement_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Preview Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <p>[Loan Agreement]</p>
          <p>
            This Loan Agreement ("Agreement") is entered into on [Date], between
            [Lender Name], located at [Address], hereinafter referred to as the
            "Lender", and [Borrower Name], located at [Address], hereinafter
            referred to as the "Borrower".
          </p>

          <p className="title">1. Loan Details:</p>
          <ul className="dotted">
            <li>Borrower Name: [Borrower Name]</li>
            <li>Loan Amount: [Loan Amount]</li>
            <li>Loan Tenure: [Loan Tenure]</li>
            <li>Rate of Interest (ROI): [Rate of Interest]</li>
            <li>Processing Fee (PF): [Processing Fee]</li>
            <li>Loan Start Date: [Loan Start Date]</li>
            <li>Loan End Date: [Loan End Date]</li>
          </ul>

          <p className="title">2. Terms and Conditions:</p>
          <ul className="letters">
            <li>
              The Loan Amount of [Loan Amount] shall be provided to the Borrower
              by the Lender.
            </li>
            <li>
              The Loan Tenure shall be [Loan Tenure] months, commencing from the
              Loan Start Date and ending on the Loan End Date.
            </li>
            <li>
              The Rate of Interest (ROI) applicable to this loan shall be [Rate
              of Interest] per annum.
            </li>
            <li>
              A Processing Fee (PF) of [Processing Fee] shall be charged by the
              Lender.
            </li>
            <li>
              The Borrower shall repay the Loan Amount along with accrued
              interest and processing fee in equal monthly installments within
              the Loan Tenure.
            </li>
            <li>
              The Borrower shall adhere to the repayment schedule as agreed upon
              in this Agreement.
            </li>
            <li>
              The Loan shall be secured by [Specify any collateral or security,
              if applicable].
            </li>
          </ul>

          <p className="title">3. Rights and Obligations:</p>
          <ul className="letters">
            <li>
              The Lender reserves the right to demand immediate repayment of the
              outstanding loan amount in case of default by the Borrower.
            </li>
            <li>
              The Borrower shall notify the Lender in writing of any change in
              contact information or financial status.
            </li>
            <li>
              The Borrower shall not assign or transfer this Agreement without
              the prior written consent of the Lender.
            </li>
          </ul>

          <p className="title">4. General Provisions:</p>
          <ul className="letters">
            <li>
              This Agreement constitutes the entire understanding between the
              parties concerning the subject matter hereof and supersedes all
              prior agreements and understandings, whether oral or written.
            </li>
            <li>
              Any modification to this Agreement must be made in writing and
              signed by both parties.
            </li>
            <li>
              This Agreement shall be governed by and construed in accordance
              with the laws of [State/Country].
            </li>
          </ul>

          <br />

          <p>
            IN WITNESS WHEREOF, the parties hereto have executed this Agreement
            as of the date first above written.
          </p>
          <p>[Lender Name] (Lender) </p>
          <p>[Borrower Name] (Borrower)</p>
          <p>[Signature] [Signature]</p>
          <p>[Printed Name] [Printed Name]</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Preview Generate Agreement Modal */}
      <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} centered size="md">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title style={{ fontWeight: 'bold', fontSize: '18px' }}>Preview Generate Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4">
          <div className="mb-4 text-muted" style={{ fontSize: '14px' }}>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Sanctioned Loan Amount</span>
              <span>: ₹{data?.sanctionedLoanAmount}</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Sanctioned Loan Tenure</span>
              <span>: {data?.sanctionedLoanTenure} Days</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Sanctioned Loan IRR</span>
              <span>: {data?.sanctionedLoanIRR}</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Sanctioned Loan Start Date</span>
              <span>: {data?.sanctionedLoanStartDate ? dayjs(data.sanctionedLoanStartDate).format("DD-MM-YYYY") : ""}</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Sanctioned Loan End Date</span>
              <span>: {data?.sanctionedLoanEndDate ? dayjs(data.sanctionedLoanEndDate).format("DD-MM-YYYY") : ""}</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Repayment Amt</span>
              <span>: ₹ {validationResponse?.calculatedTotalAmountPayable || data?.sanctionedLoanTotalAmtPayable}</span>
            </div>
            <div className="d-flex mb-3">
              <span style={{ width: '220px' }}>Net Disbursement Amt</span>
              <span>: ₹ {data?.netDisbursementAmt}</span>
            </div>
          </div>

          {validationResponse?.integrityStatus === "positive" ? (
            <div className="mb-3">
              <strong className="text-success">Success</strong>
              <p className="text-muted mt-1">{validationResponse?.message}</p>
            </div>
          ) : <div className="mb-3">
            <strong className="text-danger">Error</strong>
            <p className="text-muted mt-1">There’s is an error in <span className="fw-bold">Repayment Amt</span> please check.</p>
          </div>}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 justify-content-end">
          {validationResponse?.integrityStatus === "positive" && (
            <Button
              variant="danger"
              style={{ backgroundColor: "#DE3232", borderColor: "#DE3232", width: "120px", fontWeight: "600" }}
              onClick={handleProceedAgreement}
            >
              Proceed
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default constore(GenerateAgreement);
